const state = {
  current_record_company_id: null,
  current_record_tab_index: 0,
  
  delete_company_id: null,
  update_company_id: null,
  
  current_edit_company_id: null,
  current_row_id: null,
  
  reload_company: false,
  reload_contracts: false,
  
  reload_cis: false,
  
  reg_modal: {
    add_modal: false,
    edit_modal: false,
    company_id: null,
    company_name: null,
    ltd_reg_number: null,
  },
  
  pay_group_modal: {
    show_modal: false,
    company_name: null,
    company_id: null
  },
  
  invoice_templates_modal: {
    add_modal: false,
    edit_modal: false,
    company_name: null,
    company_id: null,
    template: {},
    hasContractorInvoiceTemplate: true, // default so that it doesn't allow add
    hasPayeInvoiceTemplate: true // default so that it doesn't allow add
  }
};

const actions = {};

const mutations = {
  SHOW_ADD_REG_MODAL(state, payload) {
    state.reg_modal.add_modal = true;
    state.reg_modal.edit_modal = false;
    state.reg_modal.company_id = payload.company_id;
    state.reg_modal.company_name = payload.company_name;
    state.reg_modal.ltd_reg_number = null;
  },
  SHOW_EDIT_REG_MODAL(state, payload) {
    state.reg_modal.add_modal = false;
    state.reg_modal.edit_modal = true;
    state.reg_modal.company_id = payload.company_id;
    state.reg_modal.company_name = payload.company_name;
    state.reg_modal.ltd_reg_number = payload.ltd_reg_number;
  },
  HIDE_REG_MODALS(state) {
    state.reg_modal.add_modal = false;
    state.reg_modal.edit_modal = false;
    state.reg_modal.company_id = null;
    state.reg_modal.company_name = null;
    state.reg_modal.ltd_reg_number = null;
  },
  
  SHOW_ADD_PAY_GROUP_MODAL(state, payload) {
    state.pay_group_modal.show_modal = true
    state.pay_group_modal.company_name = payload.company_name
    state.pay_group_modal.company_id = payload.company_id
  },
  HIDE_ADD_PAY_GROUP_MODAL(state) {
    state.pay_group_modal.show_modal = false;
    state.pay_group_modal.company_name = null;
    state.pay_group_modal.company_id = null
  },
  
  SHOW_ADD_EDIT_INVOICE_TEMPLATE_MODAL(state, payload) {
    if (payload.add) {
      state.invoice_templates_modal.add_modal = true
      state.invoice_templates_modal.edit_modal = false
      state.invoice_templates_modal.template = {}
    }
    if (payload.edit) {
      state.invoice_templates_modal.add_modal = false
      state.invoice_templates_modal.edit_modal = true
      state.invoice_templates_modal.template = payload.template
    }
    state.invoice_templates_modal.company_name = payload.company_name
    state.invoice_templates_modal.company_id = payload.company_id
    state.invoice_templates_modal.hasContractorInvoiceTemplate = payload.hasContractorInvoiceTemplate
    state.invoice_templates_modal.hasPayeInvoiceTemplate = payload.hasPayeInvoiceTemplate
  },
  HIDE_INVOICE_TEMPLATE_MODALS(state) {
    state.invoice_templates_modal.add_modal = false
    state.invoice_templates_modal.edit_modal = false
    state.invoice_templates_modal.company_name = null
    state.invoice_templates_modal.company_id = null
    state.invoice_templates_modal.template = {}
    state.invoice_templates_modal.hasContractorInvoiceTemplate = true
    state.invoice_templates_modal.hasPayeInvoiceTemplate = true
  },
  
  CURRENT_RECORD_COMPANY_ID(state, company_id) {
    state.current_record_company_id = company_id
  },
  CURRENT_EDIT_COMPANY_ID(state, company_id) {
    state.current_edit_company_id = company_id
  },
  SET_COMPANY_TAB_INDEX(state, tab_index) {
    state.current_record_tab_index = tab_index
  },
  
  SET_COMPANY_ROW_ID(state, row_id) {
    state.current_row_id = row_id;
  },
  CLEAR_COMPANY_ROW_ID(state) {
    state.current_row_id = null;
  },
  RELOAD_COMPANY(state, payload) {
    state.reload_company = payload.action;
  },
  RELOAD_COMPANY_CONTRACTS(state, payload) {
    state.reload_contracts = payload.action;
  },
  
  RELOAD_COMPANY_CIS_STATUS(state, payload) {
    state.reload_cis = payload.action;
  },
  
  SET_DELETE_COMPANY_ID(state, payload) {
    state.delete_company_id = payload;
  },
  
  SET_UPDATE_COMPANY_ID(state, payload) {
    state.update_company_id = payload;
  }
  
  // this.$bus.$emit('table::reload', {table: 'all_companies', type: 'update'});
  // this.$store.commit('SET_UPDATE_COMPANY_ID', this.edit_company_data.id);
};

export default {
  state,
  actions,
  mutations
}
